module.exports = __webpack_public_path__ + "img/icon-question-rating.614f3fff.svg";